/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */
import { Alert, DisplayHtmlContent, useFlags } from 'sarsaparilla';

type Surface = 'landing' | 'pass-details' | 'order-details';

type AtbAlertBannerProps = {
    className?: string;
    surface: Surface;
    passType?: string;
};

function AtbAlertBanner({ className, surface, passType }: AtbAlertBannerProps) {
    const { atbAlertBanner } = useFlags();

    if (!atbAlertBanner?.enabled) {
        return null;
    }

    const {
        title,
        content,
        type = 'warning',
        showOnLandingPage,
        showOnPassDetailsPage,
        showOnOrderDetailsPage,
        excludedPassTypes,
    } = atbAlertBanner;

    // Per-surface visibility gate (default to visible when the field is omitted).
    const surfaceVisibility: Record<Surface, boolean> = {
        landing: showOnLandingPage !== false,
        'pass-details': showOnPassDetailsPage !== false,
        'order-details': showOnOrderDetailsPage !== false,
    };
    if (!surfaceVisibility[surface]) {
        return null;
    }

    // Pass-type exclusion only applies to pass-scoped surfaces.
    if (surface !== 'landing' && passType && Array.isArray(excludedPassTypes)) {
        if (excludedPassTypes.includes(passType)) {
            return null;
        }
    }

    return (
        <Alert type={type} heading={title} className={className}>
            <DisplayHtmlContent html={content} />
        </Alert>
    );
}

export default AtbAlertBanner;
